"use strict";

const isStartOfSnapUnit = require("../utils/is-start-of-snap-unit");

/**
 * Moves exclusive end-date back by 1 day, when the targeted API treats end-dates as inclusive.
 */
const getInclusiveEndDate = (result, props) => {
  const { endDate } = result;
  const { inclusiveEndDate } = props;

  if (!inclusiveEndDate) {
    return result;
  }

  return {
    ...result,
    endDate: endDate.startOf("day").minus({
      days: isStartOfSnapUnit(endDate, "days") ? 1 : 0
    })
  };
};

module.exports = getInclusiveEndDate;
